import type { FloatBlockAbstract } from '@lighthouse/core'

interface HasBlockInteractionParams {
    hasAction?: boolean
    floatBlockList?: readonly FloatBlockAbstract[] | null
}

/**
 * 只把“会在点击时消费事件”的浮层触发器算作交互。
 *
 * 不能再按静态树里是否存在 overlay 后代来判断：
 * 隐藏/未激活的浮层不应该阻止父级点击，真正会拦截的只有 click-trigger，
 * 或者已经打开后由 portal 自己接管的浮层内容。
 */
export function hasClickTriggerFloat(floatBlockList?: readonly FloatBlockAbstract[] | null): boolean {
    return !!floatBlockList?.some(item => item.config.breakPoint.overlay.showOn === 'click')
}

export function hasBlockInteraction({ hasAction, floatBlockList }: HasBlockInteractionParams): boolean {
    return !!hasAction || hasClickTriggerFloat(floatBlockList)
}
